



























import { defineComponent } from "@vue/composition-api";
import { Tab } from "@/types";

export default defineComponent({
  name: "BaseTabs",
  props: {
    tabs: { type: Array as () => Tab[], required: true },
    value: {},
  },
  setup(props, { emit }) {
    const onClick = (value: string) => value !== props.value && emit("input", value);
    return { onClick };
  },
});
